import bgDark from '@/assets/images/questionnaire-bg-dark.svg'
import bgLight from '@/assets/images/questionnaire-bg-light.svg'
import { QuestionnaireView } from '@/modules/questionnaire/views/questionnaire-view'
import { useIsDarkTheme } from '@/utils/useTheme'

export const Questionnaire = () => {
  const isDark = useIsDarkTheme()

  const Background = isDark ? bgDark : bgLight

  return (
    <div className="relative flex h-screen w-screen items-center justify-center bg-white dark:bg-secondary-900">
      <img
        className="absolute md:left-12 md:top-[26px] left-4 top-4 h-[18px]"
        src={isDark ? '/logo-white.png' : '/logo-black.png'}
      />
      <Background className="absolute inset-0 h-full w-full object-cover" />
      <QuestionnaireView />
    </div>
  )
}
